import { DoubleSide, MeshPhongMaterial } from 'three';
export const DEFAULT_MESH_MATERIAL = new MeshPhongMaterial({
    color: 0xffffff,
    specular: 0xffffff,
    shininess: 30,
    side: DoubleSide,
    flatShading: false,
});
export const WIREFRAME_COLOR = 0x252525;
